/**
 * Custom inline SVG icons for the side nav rail.
 */
import { useId } from 'react';

import styles from './side-nav.module.css';

export const IconAnalyticsBars = () => (
  <>
    {/* Active page: filled bars, stroke matches the nav-bar background. */}
    <svg
      data-analytics-variant="active"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M0.636353 9.1212H5.30302V14.6364H0.636353V9.1212Z"
        fill="currentColor"
      />
      <path
        d="M5.30302 0.636353H9.96969V14.6364H5.30302V0.636353Z"
        fill="currentColor"
      />
      <path
        d="M9.96969 4.87878H14.6364V14.6364H9.96969V4.87878Z"
        fill="currentColor"
      />
      <path
        d="M5.30302 14.6364V9.1212H0.636353V14.6364H5.30302ZM5.30302 14.6364H9.96969M5.30302 14.6364V0.636353H9.96969V14.6364M9.96969 14.6364H14.6364V4.87878H9.96969V14.6364Z"
        stroke="var(--rl-sidenav-icon-stroke, #3b3e42)"
        strokeWidth="1.27273"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
    {/* Inactive page: outline only. */}
    <svg
      data-analytics-variant="inactive"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M5.3029 14.6364V9.1212H0.63623V14.6364H5.3029ZM5.3029 14.6364H9.96956M5.3029 14.6364V0.636353H9.96956V14.6364M9.96956 14.6364H14.6362V4.87878H9.96956V14.6364Z"
        stroke="currentColor"
        strokeWidth="1.27273"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  </>
);

export const IconApplicationsGrid = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M0.75 0.75H8.43182V8.43182H0.75V0.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5682 0.75H20.25V8.43182H12.5682V0.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.75 12.5682H8.43182V20.25H0.75V12.5682Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5682 16.4091C12.5682 14.2878 14.2878 12.5682 16.4091 12.5682C18.5304 12.5682 20.25 14.2878 20.25 16.4091C20.25 18.5304 18.5304 20.25 16.4091 20.25C14.2878 20.25 12.5682 18.5304 12.5682 16.4091Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconDataBuilder = () => (
  <svg
    className={styles.dataBuilderIcon}
    width="26"
    height="28"
    viewBox="0 0 26 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M16.4994 11.7539L9.49951 7.71729"
      stroke="currentColor"
      strokeWidth="1.04592"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.9997 16.887V10.665C19.9994 10.3922 19.9275 10.1243 19.7909 9.88812C19.6544 9.65195 19.4582 9.45584 19.222 9.31945L13.7776 6.2084C13.5412 6.07187 13.2729 6 12.9999 6C12.7268 6 12.4586 6.07187 12.2221 6.2084L6.77776 9.31945C6.54152 9.45584 6.34531 9.65195 6.2088 9.88812C6.07229 10.1243 6.00028 10.3922 6 10.665V16.887C6.00028 17.1599 6.07229 17.4277 6.2088 17.6639C6.34531 17.9001 6.54152 18.0962 6.77776 18.2326L12.2221 21.3436C12.4586 21.4802 12.7268 21.5521 12.9999 21.5521C13.2729 21.5521 13.5412 21.4802 13.7776 21.3436L19.222 18.2326C19.4582 18.0962 19.6544 17.9001 19.7909 17.6639C19.9275 17.4277 19.9994 17.1599 19.9997 16.887Z"
      stroke="currentColor"
      strokeWidth="1.04592"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.20947 9.85608L12.9993 13.7838L19.7892 9.85608"
      stroke="currentColor"
      strokeWidth="1.04592"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.9995 21.6158V13.776"
      stroke="currentColor"
      strokeWidth="1.04592"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.3047 11.8332V14.1665"
      stroke="currentColor"
      strokeWidth="1.04592"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconDiscoveryCompass = () => {
  const needleHoleId = useId();
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <mask id={needleHoleId}>
        <rect width="22" height="22" fill="black" />
        <path
          d="M15.25 5.75L8.60433 8.60409L6.271 15.7708L12.9377 12.9374L15.25 5.75Z"
          fill="white"
          stroke="white"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <circle cx="10.771" cy="10.7708" r="2" fill="black" />
      </mask>
      <path
        d="M20.7917 10.7708C20.7917 16.3052 16.3052 20.7917 10.7708 20.7917C5.23648 20.7917 0.75 16.3052 0.75 10.7708C0.75 5.23648 5.23648 0.75 10.7708 0.75C16.3052 0.75 20.7917 5.23648 20.7917 10.7708Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <rect
        width="22"
        height="22"
        fill="currentColor"
        mask={`url(#${needleHoleId})`}
      />
    </svg>
  );
};

export const IconReportsStack = () => {
  const backCardId = useId();
  const frontCardId = useId();
  return (
    <svg
      width="24"
      height="21"
      viewBox="0 0 24 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <mask id={backCardId}>
        <rect
          x="3.13037"
          y="3.5"
          width="20.8696"
          height="17.5"
          rx="1"
          fill="white"
        />
        <rect width="20.8696" height="17.5" rx="1" fill="black" />
      </mask>
      <rect
        x="3.13037"
        y="3.5"
        width="20.8696"
        height="17.5"
        rx="1"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        mask={`url(#${backCardId})`}
      />
      <mask id={frontCardId} fill="white">
        <rect width="20.8696" height="17.5" rx="1" />
      </mask>
      <rect
        width="20.8696"
        height="17.5"
        rx="1"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        mask={`url(#${frontCardId})`}
      />
      <path
        d="M4.5 13.5L8.5 10L11 13L16.5 7.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="4.75"
        y1="4.25"
        x2="10.25"
        y2="4.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
